import { getInitials, stringToColor } from "@4uhub/lib4uhub";
import CommentRoundedIcon from "@mui/icons-material/CommentRounded";
import {
  Avatar,
  Box,
  IconButton,
  Rating,
  Tooltip,
  Typography,
} from "@mui/material";
import { memo, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { CommentsModal } from "./CommentsModal/CommentsModal";

export const DashboardEvaluation = memo(({ data }: { data: any }) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const closeHandler = useCallback(() => {
    setOpen(false);
  }, []);

  const openHandler = useCallback(() => {
    setOpen(true);
  }, []);

  const hasJustifications =
    "justifications" in data && data.justifications.length > 0;

  return (
    <>
      {hasJustifications && (
        <CommentsModal
          open={open}
          justifications={data.justifications}
          onClose={closeHandler}
        />
      )}
      <Box
        sx={(t) => ({
          p: 2,
          display: "flex",
          alignItems: "center",
          gap: 2,
          borderRadius: 2,
          backgroundColor: t.palette.background.default,
          position: "relative",
        })}
      >
        <Avatar sx={{ backgroundColor: stringToColor(data.name) }}>
          {getInitials(data.name)}
        </Avatar>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography sx={{ fontWeight: 700 }}>{data.name}</Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Typography
              variant="h5"
              sx={(t) => ({
                color:
                  Number(data.average) >= 4
                    ? t.palette.success.main
                    : Number(data.average) >= 3
                    ? t.palette.warning.main
                    : t.palette.error.main,
              })}
            >
              {parseFloat(data.average).toFixed(1)}
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Rating
                value={Number(data.average)}
                precision={0.5}
                size="small"
                readOnly
              />
              <Typography variant="subtitle2">
                {data.evaluationsQty} {t("components.panel.reviews")}
              </Typography>
            </Box>
          </Box>
        </Box>
        {hasJustifications && (
          <Tooltip title={t("components.panel.view_comments")}>
            <IconButton
              size="small"
              sx={{ position: "absolute", right: 5, bottom: 5 }}
              onClick={openHandler}
            >
              <CommentRoundedIcon fontSize="small" color="primary" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </>
  );
});
